import React from 'react';
import TermsHeader from '../../components/TermsHeader';

const TermsAndConditions = () => {
  return (
    <div id="terms-wrapper">
        <TermsHeader title="UNI Drive" />
        <div className="terms-page">
            <h1>Uni Drive Terms and Conditions</h1>
            <p>
                Welcome to Uni Drive! These terms and conditions outline the rules and
                regulations for the use of our cab sharing app. By using Uni Drive, you
                accept and agree to be bound by these terms and conditions. If you
                disagree with any part of these terms and conditions, please do not use
                our app.
            </p>
            <h2>1. User Conduct</h2>
            <p>
                By using Uni Drive, you agree to conduct yourself in a responsible and
                respectful manner. This includes treating drivers and other passengers
                with courtesy and following any applicable laws and regulations.
            </p>
            <h2>2. Safety and Liability</h2>
            <p>
                Uni Drive prioritizes the safety of all users. While we strive to
                provide a secure platform, we cannot guarantee the actions or behavior
                of drivers or passengers. Users are responsible for their own safety
                and should exercise caution when using the app. Uni Drive will not be
                liable for any damages, injuries, or losses incurred during a ride.
            </p>
            <h2>3. Fare Calculation and Payments</h2>
            <p>
                Uni Drive uses a fare calculation system based on distance, time, and
                other factors. The fares displayed in the app are estimates and may vary
                due to traffic conditions or other unforeseen circumstances. Users are
                responsible for paying the agreed-upon fare through the app's payment
                system.
            </p>
            {/* More terms and conditions sections go here */}
            <h2>6. Intellectual Property</h2>
            <p>
                The Uni Drive app, including its design, logo, and content, is the
                intellectual property of Uni Drive. Users may not reproduce, distribute,
                or modify any part of the app without explicit permission from Uni
                Drive.
            </p>
            <h2>7. Modifications</h2>
            <p>
                Uni Drive reserves the right to modify or update these terms and
                conditions at any time. It is the responsibility of the users to review
                the terms periodically. Continued use of the app after any modifications
                constitutes acceptance of the updated terms and conditions.
            </p>
            <p>
                Please review the full terms and conditions carefully before using Uni
                Drive. If you have any questions or concerns, please contact us at
                info@pands.app.
            </p>
        </div>
        <PrivacyPolicy/>
    </div>
  );
};

const PrivacyPolicy = () => {
  return (
    <div className="terms-page">
      <h1>Privacy Policy</h1>
      
      <h2>1. Introduction</h2>
      <p>
        UniDriver ("the App") is a ride share application that connects riders with drivers to facilitate transportation services. At UniDriver, we value your privacy and are committed to protecting your personal information. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you use the UniDriver App as a rider. By using the App, you consent to the practices described in this Privacy Policy.
      </p>
      
      <h2>2. Information We Collect</h2>
      <br/>
      <h3>2.1. Personal Information</h3>
      <br/>
      <span>
            When you sign up for UniDriver as a rider, we may collect the following personal information:
            <br/>
            Full name
            <br/>           
            Email address
            <br/>
            Phone number
            <br/>
            Profile picture (optional)
      </span>
      <br/>
      <br/>
      <h3>2.2. Location Information</h3>
      <p>
      UniDriver requires access to your device's location to provide ride services. We collect and store your location data when you use the App, including pick-up and drop-off locations. This information is necessary to connect you with nearby drivers and facilitate the transportation service.
      </p>
      <br/>
      <br/>
      <h3>2.3. Usage Information</h3>
      <span>
            We collect information about your interaction with the App, including:
            <br/>
            Ride history and details, such as pick-up and drop-off times and locations
            <br/>
            Ratings and reviews provided by you and other riders
            <br/>
            App usage metrics, device information, and mobile network information
      </span>
      <br/>
      <br/>
      <h3>2.4. Communication Data</h3>
      <p>
      We may collect information when you communicate with us or other users through the App, including messages, feedback, and support inquiries.
      </p>
      
      <h2>3. Use of Information</h2>
      <span>
        We use the collected information for the following purposes:
        <br/>
        <br/>
        3.1. Providing and Improving Services
        <br/>
        Facilitating rides and connecting you with nearby drivers
        Verifying your identity and ensuring a secure and personalized experience
        Processing payments for transportation services
        Enhancing the overall functionality, performance, and user experience of the App
        <br/>
        <br/>
        3.2. Safety and Security
        <br/>
        Verifying driver qualifications and conducting background checks
        Monitoring rides for safety purposes and ensuring compliance with our terms of service
        Preventing fraudulent activities and protecting the rights and safety of riders and drivers
        <br/>
        <br/>
        3.3. Customer Support
        <br/>
        Responding to your inquiries, feedback, and support requests
        Resolving issues or disputes related to your use of the App
        <br/>
        <br/>
        3.4. Personalization
        <br/>
        Customizing and personalizing your experience with UniDriver
        Suggesting relevant promotions, features, and content based on your preferences and location
        <br/>
        <br/>
        3.5. Communication
        <br/>
        Sending important updates, notifications, and service-related messages
        Delivering marketing communications, promotions, and offers with your consent (which can be revoked at any time)
      </span>
      
      <h2>4. Disclosure of Information</h2>
      <span>
        We may disclose your information in the following circumstances:
        <br/>
        <br/>
        4.1. Service Providers
        <br/>
        We may share your information with trusted third-party service providers who assist us in operating, managing, and enhancing the App. These service providers are bound by confidentiality agreements and are only authorized to use your information as necessary to provide the contracted services.
        <br/>
        <br/>
        4.2. Legal Requirements
        <br/>
        We may disclose your information if required to do so by law, court order, or governmental authority. We may also disclose your information to protect our rights, safety, or the rights, safety, or property of others.
        <br/>
        <br/>
        4.3. Business Transfers
        <br/>
        In the event of a merger, acquisition, or sale of all or a portion of our assets, your information may be transferred or disclosed as part of the transaction. We will notify you of any such change in ownership or control of your personal information.
      </span>
      
      <h2>5. Data Retention</h2>
      <p>
      We retain your personal information for as long as necessary to fulfill the purposes outlined in this Privacy Policy, unless a longer retention period is required or permitted by law. We will delete or anonymize your information when it is no longer needed.
      </p>
      
      <h2>6. Security</h2>
      <p>
      We implement reasonable security measures to protect your personal information from unauthorized access, use, or disclosure. However, no data transmission over the internet or method of electronic storage can be guaranteed to be 100% secure. Therefore, while we strive to protect your information, we cannot guarantee its absolute security.
      </p>
      
      <h2>7. Your Rights</h2>
      <p>
        You have certain rights regarding your personal information, including the right to:
        <br/>
        <br/>
        1. Access, correct, or update your personal information
        <br/>
        2. Object to the processing of your personal information
        <br/>
        3. Request the deletion of your personal information
        <br/>
        4. Opt-out of receiving marketing communications
        <br/>
        5. Lodge a complaint with the appropriate data protection authority
        <br/>
        <br/>
        To exercise any of these rights or for any privacy-related inquiries, please contact us using the contact information provided at the end of this Privacy Policy.
      </p>
      
      <h2>8. Children's Privacy</h2>
      <p>
      UniDriver is not intended for use by individuals under the age of 18. We do not knowingly collect personal information from children. If you become aware that a child has provided us with their personal information without parental consent, please contact us, and we will take steps to remove the information from our systems.
      </p>
      
      <h2>9. Changes to this Privacy Policy</h2>
      <p>
      We may update this Privacy Policy from time to time. We will notify you of any material changes by posting the revised version on our website or through other communication channels. We encourage you to review this Privacy Policy periodically for any updates.
      </p>
      
      <h2>10. Contact Us</h2>
      <p>
      If you have any questions, concerns, or requests regarding this Privacy Policy or the handling of your personal information, please contact us at: info@pands.app
      </p>
    </div>
  );
}

export default TermsAndConditions;
